module.exports = __webpack_public_path__ + "img/BE0423454191.feba1351.png";